
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconArrowDown',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 15
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 9
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
})
